import styled from "styled-components"

import Address from "@irati-web/geolocation/src/components/Address/Address"

export const StyledAddress = styled(Address)`
  min-width: 150px;
`
